module.exports = __webpack_public_path__ + "img/plus-icon-white.ccf7c28d.svg";